export class AbsatzProduktivitaet {
  constructor({
    stueck,
    mpt,
  }: {
    readonly stueck?: number;
    readonly mpt?: number;
  }) {
    this.mpt = mpt;
    this.stueck = stueck;
  }
  readonly stueck?: number;
  readonly mpt?: number;
}

export class Absatz {
  constructor({
    produktivitaet,
    wert,
    stunden,
  }: {
    produktivitaet: AbsatzProduktivitaet;
    wert?: number;
    stunden?: number;
  }) {
    this.produktivitaet = produktivitaet;
    this.stunden = stunden;
    this.wert = wert;
  }

  readonly produktivitaet: AbsatzProduktivitaet;
  readonly wert?: number;
  readonly stunden?: number;
}

export class AbsatzPlan {
  constructor({
    absatz,
    prognose,
  }: {
    readonly absatz: Absatz;
    readonly prognose: number;
  }) {
    this.absatz = absatz;
    this.prognose = prognose;
  }

  readonly absatz: Absatz;
  readonly prognose: number;
}
